import { useQuery } from '@tanstack/react-query'
import { type BookingRevocationEligibilityDto } from '../../../qourses-api-client'
import { qoursesApi } from '../../api/qourses.tsx'

export default function useGetBookingRevocationEligibility(
  bookingId: string,
  overrideRevocationPolicy = false,
): {
  bookingRevocationEligibility: BookingRevocationEligibilityDto
  isLoading: boolean
  isError: boolean
  refetch: () => void
  isRefetching: boolean
} {
  const {
    data: bookingRevocationEligibility,
    isLoading,
    isError,
    refetch,
    isRefetching,
  } = useQuery(['booking', bookingId, 'revocationEligibility', overrideRevocationPolicy], async () => {
    return qoursesApi.payment.paymentControllerGetBookingRevocationEligibilityV1(
      bookingId,
      overrideRevocationPolicy,
    )
  })

  return { bookingRevocationEligibility, isLoading, isError, refetch, isRefetching }
}
